<template lang="pug" src="./treatments.pug"></template>

<script>
import HeroPages from 'components/hero/hero-pages/hero-pages'
import BlockIconContent from 'components/block/block-icon-content/block-icon-content'
import BlockSectionBackground from 'components/block/block-section-background/block-section-background'
import CustomTreatmentsPhases from 'components/custom/custom-treatments-phases/custom-treatments-phases'
import BannerImageContentButton from 'components/banner/banner-image-content-button/banner-image-content-button'
import CustomTreatmentsBraces from 'components/custom/custom-treatments-braces/custom-treatments-braces'
import FormRequest from 'components/form/form-request/form-request'

export default {
  computed: {
    props () {
      return this.$store.state.pages['treatments']
    }
  },
  components: {
    HeroPages,
    BlockIconContent,
    BlockSectionBackground,
    CustomTreatmentsPhases,
    BannerImageContentButton,
    CustomTreatmentsBraces,
    FormRequest
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/treatments/treatments.vue